import Add20 from '@carbon/icons-react/es/add/20';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router';
import styled from 'styled-components';
import { EmptyState as EmptyStateAtom } from 'components/atoms/empty-state';
import { getNewWidgetUrl } from 'utils/urls';
import { useDashboardInfo } from '../useDashboardInfo';
import { ReactComponent as EmptyWidgetIcon } from './empty-widget.svg';

const EmptyStateContainer = styled.div`
  position: absolute;
  top: 40%;
  left: 185px;
`;

export const EmptyState: FC = () => {
  const {
    selectedDashboard: { selectedId },
  } = useDashboardInfo();
  const history = useHistory();
  const { search } = useLocation();

  const onNewChartClick = () => {
    history.push(getNewWidgetUrl(selectedId, search));
  };

  return (
    <EmptyStateContainer>
      <EmptyStateAtom
        image={<EmptyWidgetIcon />}
        title={<FormattedMessage id="dashboard.empty.title" />}
        message={<FormattedMessage id="dashboard.empty.body" />}
        primaryCTA={
          <EmptyStateAtom.CallToAction.Primary
            icon={<Add20 />}
            onClick={onNewChartClick}
          >
            <FormattedMessage id="dashboard.new_chart" />
          </EmptyStateAtom.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
